export default __webpack_public_path__ + "static/media/sass.ec9faee7.png";